import { assign } from "xstate";
import { track } from "../../actions";
export const estimationScreenState = {
    entry: [track],
    on: {
        NEXT: "price",
        SET_ESTIMATION: {
            actions: "setEstimation",
        },
        SET_ZIP_CODE: {
            actions: "setZipCode",
        },
        PRICE: {
            target: "price",
        },
        SET_RESIDENCE_TYPE: {
            actions: "setResidenceType",
        },
    },
};
